// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__aEoV+","active":"Tab_active__9omV3"};